module.exports = __webpack_public_path__ + "static/media/LetMeAskRounded.5c9f50bd.png";